import about from '../../data/about.json';
import type { AppDef } from '../../types/window';
import { el } from './dom';

export const aboutApp: AppDef = {
  appId: 'about',
  title: 'About',
  icon: 'about',
  defaultSize: { w: 420, h: 280 },
  singleton: true,
  mount(root) {
    const wrap = el('div', { className: 'app-stack' });
    wrap.append(
      el('h1', { text: about.headline }),
      el('p', { text: about.body }),
    );
    root.replaceChildren(wrap);
    return () => root.replaceChildren();
  },
};
